<template>
  <div>
    <div v-if="packageData" class="order-info">
      <div class="order-info-box">
        <h1>{{ packageData.name }}</h1>
        <h1>{{ packageData.date }}</h1>
      </div>
    </div>
    <div class="order-modal-split">
      <div class="order-modal-details">
        <h3>{{ $t("פרטי המזמין") }}</h3>

        <label>
          {{ $t("שם מלא") }}
          <input v-model="form.customer.name" type="text" />
        </label>

        <label>
          {{ $t("טלפון") }}
          <input
            v-model="form.customer.phone"
            type="tel"
            @blur="validatePhone = true"
            :class="{
              error:
                (validatePhone && !isPhoneValid()) ||
                form.customer.phone.length > 10
            }"
          />
          <span
            style="font-size: 13px; color: red"
            v-if="
              (validatePhone && !isPhoneValid()) ||
                form.customer.phone.length > 10
            "
            >{{ $t("אנא הזן בין 9 ל-10 ספרות") }}</span
          >
        </label>

        <label>
          {{ $t("אימייל") }}
          <input
            v-model="form.customer.email"
            type="email"
            @blur="validateEmail = true"
            @focus="validateEmail = false"
            :class="{ error: validateEmail && !isEmailValid() }"
          />
          <span
            style="font-size: 13px; color: red"
            v-if="validateEmail && !isEmailValid()"
            >{{ $t("אנא הזן כתובת אימייל תקנית") }}</span
          >
        </label>
      </div>
      <div class="order-modal-people">
        <h3>{{ $t("כמה גולשים?") }}</h3>
        <ul>
          <li v-for="(group, i) in form.ageGroups" :key="i">
            <span>{{ group.name }}</span>
            <CountControl
              :value="group.wantedCount"
              @plus="form.ageGroups[i].wantedCount++"
              @minus="
                () => {
                  if (form.ageGroups[i].wantedCount > 0)
                    form.ageGroups[i].wantedCount--;
                }
              "
              :size="countControlSize"
            />
          </li>
        </ul>
      </div>
    </div>
    <ModalNextButton
      @next="onNext"
      @back="$emit('done', { event: 'back' })"
      :loading="submitting"
      :disabled="submitting || !canSubmit()"
    />
  </div>
</template>

<script>
import ModalNextButton from "./ModalNextButton.vue";
import CountControl from "./CountControl.vue";
import { api } from "../../API";
import { $t } from "../../i18n";

export default {
  components: { ModalNextButton, CountControl },
  props: {
    value: {
      type: Object
    },
    packageData: {
      type: Object
    },
    show: {
      type: Boolean
    }
  },
  data() {
    return {
      form: JSON.parse(JSON.stringify(this.value)) || {},
      submitting: false,
      countControlSize: window.innerWidth < 992 ? 28 : 44,
      validatePhone: false,
      validateEmail: false
    };
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.countControlSize = window.innerWidth < 992 ? 28 : 44;
    },
    onNext() {
      this.submitting = true;
      $.when(
        $.ajax({
          method: "POST",
          url: "https://skideal-orders.ynadev.com/api/packages/find",
          data: JSON.stringify({ ...this.packageData, people: this.people }),
          contentType: "application/json",
          headers: {
            Accept: "application/json"
          }
        }),
        $.ajax(
          api.ajaxOptions(
            "POST",
            "/orders/package-info/" + this.packageData.internalId,
            {
              json: {
                name: this.form.customer.name,
                phone: this.form.customer.phone,
                people: this.people
              }
            }
          )
        )
      )
        .done(([packageResponse], [infoResponse]) => {
          this.$emit("done", {
            event: "next",
            setData: { ...packageResponse, packageInfo: infoResponse }
          });
        })
        .fail(err => {
          this.$emit("done", {
            event: "error",
            error: err,
            orderStatus: err.responseJSON ? err.responseJSON.error : ""
          });
          console.log("err", err);
        })
        .always(() => (this.submitting = false));
    },

    canSubmit() {
      return (
        this.people > 0 &&
        this.form.customer.name.trim().length &&
        this.isPhoneValid() &&
        this.isEmailValid()
      );
    },

    isPhoneValid() {
      let phoneLength = this.form.customer.phone.replace(/[^\d]/, "").length;
      return phoneLength >= 9 && phoneLength <= 10;
    },

    isEmailValid() {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(this.form.customer.email.toLowerCase());
    }
  },
  computed: {
    people() {
      let people = 0;

      for (let i in this.form.ageGroups) {
        const group = this.form.ageGroups[i];

        if (group.age >= 12) {
          people += group.wantedCount || 0;
        }
      }

      return people;
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit("input", JSON.parse(JSON.stringify(this.form)));
      }
    },
    show() {
      if (this.show) {
        this.validatePhone = false;
        this.validateEmail = false;

        // this.form = {
        //   customer: {
        //     name: "",
        //     phone: "",
        //     email: ""
        //   },
        //   ageGroups: [
        //     { age: 18, name: $t("מבוגרים"), wantedCount: 0 },
        //     { age: 12, name: $t("ילדים מתחת לגיל 12"), wantedCount: 0 },
        //     { age: 2, name: $t("תינוקות 0-2"), wantedCount: 0 }
        //   ],
        //   rooms: []
        // };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.order-info {
  padding-top: 20px;
  .order-info-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    font-family: "Almoni Neue DL 4.0 AAA";
    h1 {
      font-family: "Almoni Neue DL 4.0 AAA";
      font-weight: bold;

      @media screen and (max-width: 991px) {
        font-size: 25px;
      }
    }
  }
}
.order-modal-split {
  padding-top: 103px !important;
  margin-bottom: 15px;
  display: flex;

  @media screen and (max-width: 991px) {
    padding-top: 0 !important;
  }

  > div {
    padding: 0 40px !important;

    @media screen and (max-width: 991px) {
      padding: 0 15px !important;
    }

    &:first-child {
      border-color: #979797 !important;
    }
  }

  h3 {
    font-size: 33px !important;
    font-weight: 900 !important;
    text-align: right !important;

    @media screen and (max-width: 991px) {
      font-size: 19px !important;
      text-align: center !important;
      margin-bottom: 18px !important;
    }
  }

  input {
    color: #2b3648 !important;
    font-size: 19px !important;
    font-weight: bold;
    letter-spacing: 0 !important;
  }
}

.order-modal-people {
  > ul {
    > li {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 23px;

      > span {
        flex-grow: 1;
        color: #2b3648;
        font-size: 18px;
        font-weight: bold;

        @media screen and (max-width: 991px) {
          font-weight: normal !important;
        }
      }
    }
  }
}

.order-modal-details {
  label {
    input {
      &.error {
        border-color: red;
      }
    }
  }
}
</style>
